/**
 * Message the studio (web-studio-sites D15): "Questions about this service?"
 * with Message the studio, which opens the messages panel; a visitor signs in
 * with Telegram first and the panel opens once they are signed in. On Telify's
 * service and event pages when the site turns it on, as a booking's page's
 * Questions block, and placed on a custom page.
 */
import { definePiece } from '../../contract/define';

export const contract = definePiece({
  name: 'message-studio',
  description:
    'A heading and a line asking for questions, with Message the studio, which opens the messages panel; a visitor signs in with Telegram first.',
  placeable: true,
  options: {
    heading: {
      type: 'string',
      default: null,
      maxLength: 80,
      description:
        'The heading. Unset: "Questions about this service?" or "Questions about this event?" on Telify\'s pages, "Questions before you book?" on a page of the site.',
    },
  },
  parts: {
    section: { description: 'The whole block.', required: false },
    logo: { description: "The studio's logo beside the words, when it has one.", required: false },
    title: { description: 'The heading.', required: false, role: 'title' },
    line: { description: 'Message <studio>.', required: false },
    messageStudio: {
      description: 'Message the studio: opens the messages panel; for a visitor, Telegram\'s sign-in window first.',
      required: false,
      role: 'secondary-action',
    },
    signInError: { description: 'Under the button when the sign-in it started did not go through.', required: false },
  },
  actions: {
    messageStudio: {
      description: "Opens the messages panel; for a visitor, opens Telegram's sign-in window and then the panel once signed in, on the same page.",
      args: [],
    },
  },
  events: {},
});

/** What Message the studio knows. */
export interface MessageStudioState {
  /** loading until the studio's profile is known. */
  readonly status: 'loading' | 'ready';
  /** "Questions about this session?" */
  readonly heading: string;
  /** "Message Dana Wilcher Art." */
  readonly line: string;
  /** The studio's logo, or null to draw the words alone. */
  readonly logoUrl: string | null;
  /** True when the button can act: signed in, or a visitor once Telegram's sign-in is ready. */
  readonly ready: boolean;
  /** True while Telegram's sign-in window, opened from this button, is open. */
  readonly signingIn: boolean;
  /** True after a sign-in this button started did not go through. */
  readonly signInFailed: boolean;
}

/** What a drawing can ask Message the studio to do. */
export interface MessageStudioActions {
  /** Open the messages panel, signing a visitor in first. */
  readonly messageStudio: () => void;
}

/** Message the studio tells its host nothing of its own. */
export type MessageStudioEvents = Record<string, never>;
